module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowMedium.db19cb7.woff";